import { useCallback, useRef, useState } from 'react';

export interface UseHoverCardOptions {
  delayMs?: number;
}

export const useHoverCard = ({ delayMs = 150 }: UseHoverCardOptions = {}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  const openCard = useCallback((el: HTMLElement) => {
    clearTimeout(timeout.current);
    setAnchorEl(el);
  }, []);

  const closeCard = useCallback(() => {
    timeout.current = setTimeout(() => setAnchorEl(null), delayMs);
  }, [delayMs]);

  const cancelClose = useCallback(() => clearTimeout(timeout.current), []);

  return { anchorEl, openCard, closeCard, cancelClose };
};
